import { render, staticRenderFns } from "./DialogPatent.vue?vue&type=template&id=22cd6ca1&"
import script from "./DialogPatent.vue?vue&type=script&lang=js&"
export * from "./DialogPatent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports